module.exports = __webpack_public_path__ + "static/media/eyescan10.da16e3db.png";